import { connect } from 'react-redux'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import * as salesOrderSelector from '../../../sales-order/state/detail/selector'
import TreatmentPaymentWidget from './TreatmentPaymentWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
        salesOrder: salesOrderSelector.selectSalesOrder(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(TreatmentPaymentWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/TreatmentPaymentWidgetContainer.js